import React, { useState, useEffect } from "react";
import CustomFilters from "../../../../core/custom-filters";
import { Box, TextField } from "@mui/material";
import { HTTP_METHODS, plainApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import SiAutocomplete from "../../../../core/si-autocomplete";
import SiTextField from "../../../../core/si-textfield";

const ServiceInfoFilters = () => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [searchEngineOptions, setSearchEngineOptions] = useState([]);
  const [selectedSearchEngine, setSelectedSearchEngine] = useState("");

  let engineTimeout = null;

  const applyFilters = (filters) => {
    console.log("Applied Filters:", filters);
  };
  const loadEngines = async (inputValue) => {
    try {
      const response = await plainApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.SEARCH_ENGINE_LIST}`,
        { searchTerm: inputValue }
      );
      setSearchEngineOptions(
        response.map((item) => ({
          label: item,
          value: item,
        }))
      );
    } catch (error) {
      console.error("Error fetching engine options:", error);
    }
  };
  const handleEngineSearch = (newInputValue) => {
    if (newInputValue) {
      clearTimeout(engineTimeout);
      engineTimeout = setTimeout(() => loadEngines(newInputValue), 300);
    }
  };
  const filterTypes = [
    { label: "Filter by Engine", value: "engineModel" },
    { label: "Filter by Release Date", value: "releaseDate" },
  ];

  const renderFilterInput = () => {
    switch (filterType) {
      case "engineModel":
        return (
          <SiAutocomplete
            value={selectedSearchEngine}
            onChange={setSelectedSearchEngine}
            options={searchEngineOptions}
            placeholder="Search Engine"
            onInputChange={(newInputValue) => handleEngineSearch(newInputValue)}
            // clearIcon={
            //   <ClearIcon
            //     fontSize="small"
            //     onClick={() => {
            //       setStaticFormData({});
            //       setFormData({});
            //     }}
            //   />
            // }
          />
        );
      case "releaseDate":
        return (
          <Box sx={{ display: "flex", gap: "20px" }}>
            <SiTextField
              placeholder="Start Date"
              name="startDate"
              type="date"
              onChange={handleFilterValueChange}
            />

            <SiTextField placeholder="End Date" name="endDate" type="date" />
          </Box>
        );

      default:
        return null;
    }
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default ServiceInfoFilters;
